import { createRouter, createWebHashHistory } from "vue-router";

import { useAuthStore } from '@/stores/auth' 
import { storeToRefs } from 'pinia'
// import { getActivePinia } from 'pinia'

import Home from "./views/home-page";
import Profile from "./views/profile-page";
import Tasks from "./views/tasks-page";

import DockerAllContainers  from "./views/docker-all-containers";
import DockerStats from "./views/docker-stats.vue";
import DockerContainersWithNetworks from "./views/docker-containers-with-networks.vue";
import DockerNetworksWithContainers from "./views/docker-networks-with-containers.vue";
import DockerNetworks from "./views/docker-networks.vue";

import Docker from "./views/node-agents-page";
import Docker2 from "./views/node-agents-page-2";
import HAProxyConfig from "./views/haproxy-config";
import HAProxyConfigValidate from "./views/haproxy-config-validate";
import HAProxyCerts from "./views/haproxy-certs";
import HAProxyCerts2 from "./views/haproxy-certs-2";

import NginxSites from "./views/nginx-sites";

import CloudflareDNSrecords from "./views/cloudflare-dns-records.vue";
import CloudflareDnsRecordsAll from "./views/cloudflare-dns-records-all.vue";
import CloudflareDNSzones from "./views/cloudflare-dns-zones.vue";
import WordpressSiteSnaphots from "./views/wordpress-site-snapshots.vue";

// component: () => import('./views/node-agents-page.vue')

import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";


function loadView(view) {
  return () => import (/* webpackChunkName: "login" */ `./views/${view}.vue`)
}

const router = new createRouter({
  routes: [
    {
      path: "/home",
      name: "home",
      meta: {
        requiresAuth: false,
        layout: defaultLayout
      },
      component: Home
    },
    {
      path: "/profile",
      name: "profile",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Profile
    },
    {
      path: "/tasks",
      name: "tasks",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Tasks
    },
    {
      path: "/docker-all-containers",
      name: "All Containers",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: DockerAllContainers
    },
    {
      path: "/docker-stats",
      name: "Stats",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: DockerStats
    },
    {
      path: "/docker-containers-with-networks",
      name: "Containers with Networks",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: DockerContainersWithNetworks
    },
    {
      path: "/docker-networks-with-containers",
      name: "Networks with Containers",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: DockerNetworksWithContainers
    },
    {
      path: "/docker-networks",
      name: "Networks",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: DockerNetworks
    },
    {
      path: "/node-agents",
      name: "NodeAgents",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: Docker
    },
    {
      path: "/node-agents-2",
      name: "NodeAgents2",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: Docker2
    },
    {
      path: "/haproxy-config-validate",
      name: "haproxy-config-validate",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: HAProxyConfigValidate
    },
    {
      path: "/haproxy-config",
      name: "haproxy-config",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: HAProxyConfig
    },
    {
      path: "/haproxy-certs",
      name: "haproxy-cert",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: HAProxyCerts
    },
    {
      path: "/haproxy-certs-2",
      name: "haproxy-cert-2",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: HAProxyCerts2
    },
    {
      path: "/nginx-sites",
      name: "nginx-sites",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: NginxSites
    },
    {
      path: "/cloudflare-dns-records",
      name: "cloudflare-dns-records",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: CloudflareDNSrecords
    },    
    {
      path: "/cloudflare-dns-records-all",
      name: "cloudflare-dns-records-all",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: CloudflareDnsRecordsAll
    },
    {
      path: "/cloudflare-dns-zones",
      name: "cloudflare-dns-zones",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: CloudflareDNSzones
    },
    {
      path: "/wordpress-site-snapshots",
      name: "wordpress-site-snapshots",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
        // title: 'Node Agents'
      },
      component: WordpressSiteSnaphots
    },
    {
      path: "/login-form",
      name: "login-form",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign In"
      },
      component: loadView("login-form")
    },
    {
      path: "/reset-password",
      name: "reset-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Reset Password",
        description: "Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
      },
      component: loadView("reset-password-form")
    },
    {
      path: "/create-account",
      name: "create-account",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign Up"
      },
      component: loadView("create-account-form"),
    },
    {
      path: "/change-password/:recoveryCode",
      name: "change-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Change Password"
      },
      component: loadView("change-password-form")
    },
    {
      path: "/",
      // redirect: "/home" // Default route
      redirect: "/login-form" // Default route
    },
    {
      path: "/recovery",
      // redirect: "/home"
      redirect: "/login-form"
    },
    // {
    //   path: "/recovery",
    //   // redirect: "/home"
    //   redirect: "/reset-password"
    // },
    {
      path: "/:pathMatch(.*)*",
      // redirect: "/home"
      redirect: "/login-form"
    },
    // {
    //   path: "/:pathMatch(.*)*",
    //   name: "not-found",
    //   component: () => import("./views/not-found.vue")
    // }, 
    {
      path: '/admin-panel',
      component: () => import('./views/admin-dashboard.vue'),
      meta: { requiresAuth: true, role: 'admin' }
    },
    {
      path: '/user-dashboard',
      component: () => import('./views/user-dashboard.vue'),
      meta: { requiresAuth: true, role: 'user' }
    }
  ],
  history: createWebHashHistory()
});



// router.beforeEach((to, from, next) => {
//   const pinia = getActivePinia()
//   const store = useAuthStore(pinia)  // ✅ Important fix for router context
//   const { token, user } = storeToRefs(store)

//   const isAuth = !!token.value
//   const userRole = user.value?.role
//   const requiredRole = to.meta.role

//   console.log('[Route Guard] →', to.fullPath)
//   console.log('Token:', token.value)
//   console.log('User role:', userRole)

//   if (to.meta.requiresAuth && !isAuth) {
//     return next({
//       name: 'login-form',
//       query: { redirect: to.fullPath }
//     })
//   }

//   if (requiredRole && userRole !== requiredRole) {
//     return next('/unauthorized')
//   }

//   next()
// })


router.beforeEach((to, from, next) => {
  const store = useAuthStore()
  const { token, user } = storeToRefs(store)

  console.log('[Route Guard] →', to.fullPath)
  console.log('Token:', token.value)
  console.log('User role:', user.value?.role)

  const isAuth = !!token.value
  const requiredRole = to.meta.role

  // ✅ Token expiry check
  if (isAuth) {
    try {
      const payload = JSON.parse(atob(token.value.split('.')[1]))
      const now = Math.floor(Date.now() / 1000)

      if (payload.exp < now) {
        console.warn('[Auth] Token expired')
        store.logout()
        return next({ name: 'login-form', query: { redirect: to.fullPath } })
      }
    } catch (err) {
      console.error('[Auth] Token decode error:', err)
      store.logout()
      return next({ name: 'login-form', query: { redirect: to.fullPath } })
    }
  }

  if (to.meta.requiresAuth && !isAuth) {
    return next({ name: 'login-form', query: { redirect: to.fullPath } })
  }

  if (requiredRole && user.value?.role !== requiredRole) {
    return next('/unauthorized')
  }

  next()
})



export default router